import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Search } from "react-bootstrap-table2-toolkit";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../api/index";
import ClickAwayListenerHelper from "../../Utils/ClickAwayListenerHelper";
import * as BsIcons from "react-icons/bs";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import moment from "moment";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Chip from "@mui/material/Chip";
import DesktopDateRangePicker from "@mui/lab/DesktopDateRangePicker";
import { Box, Typography } from "@mui/material";
import { toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-alpine.css";
import PDFExportPanel from "../Reports/pdfExport/PDFExportPanel";
import "ag-grid-enterprise";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import MockLoaderTable from "../Folios/ViewManagePayments/MockLoaderTable";
import Stack from "@mui/material/Stack";
import HouseKeepingAnalytics from "./Helpers/HouseKeepingAnalytics";
import { getAllStaffsData } from "./HouseKeepingApi";
import { Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import InfoIcon from "@mui/icons-material/Info";
import {
  getAllNonHiddenRoomTypes,
  unBlockMultipleRooms,
} from "../InventoryCalendar/api/InventoryApi";
import CustomReportPdf from "../Reports/utils/CustomReportPdf";
import ClickAwayListener from "@mui/base/ClickAwayListener";
import * as RiIcons from "react-icons/ri";
import SettingsIcon from "@mui/icons-material/Settings";
import { useTranslation } from "react-i18next";
import i18n from "../../modules/Auth/pages/i18n";
import axios from "axios";
import HouseKeepingAnalytics2 from "./Helpers/HouseKeepingAnalytics2";

const styles = {
  position: "absolute",
  top: 35,
  right: 0,
  left: 0,
  zIndex: 1,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  lineHeight: 24,
  borderRadius: "5px",
};

function HouseKeepingCharterTable2(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);
  const { SearchBar } = Search;

  const [products, setProducts] = useState([]);
  const [subUser, setsubUser] = useState(
    props?.data?.accessControl?.ADMINRIGHTS
  );

  const hotelId = props.data.hotelId;
  // console.log(products)

  const [pickDate, setPickDate] = useState(new Date());
  const [hkAdminDate, sethkAdminDate] = useState(new Date());
  const [DateEqual, setDateEqual] = useState(true);
  const [loggedInemail, setloggedInemail] = useState("");

  const reportType = "HouseKeeping Charter";

  useEffect(() => {
    setloggedInemail(localStorage.getItem("email"));
  }, [localStorage.getItem("email")]);

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const handleChange = (newValue) => {
    setPickDate(newValue);
  };

  //Calling the summary data while changing the date
  useEffect(() => {
    if (
      loggedInemail !== "" &&
      loggedInemail !== undefined &&
      loggedInemail !== null
    ) {
      setloader(true);
      getHkSummaryData();
      setloader(false);
    }
  }, [pickDate, loggedInemail, subUser, filterValues]);

  const handleMarkOOOChange = (newValue) => {
    setPickDate(newValue);
  };

  const [remark, setRemark] = useState("");
  const [staffRemark, setstaffRemark] = useState("");
  // filter params for the date filter
  const filterParams = {
    debounceMs: 500,
    suppressAndOrCondition: true,
    comparator: function (filterLocalDateAtMidnight, cellValue) {
      if (cellValue == null) {
        return 0;
      }
      //   console.log(moment(dateParts).format("DD-MM-YYYY"))
      var dateParts = moment(cellValue).format("DD-MM-YYYY");
      const formattedDateParts = dateParts.split("-");
      var year = Number(formattedDateParts[2]);
      var month = Number(formattedDateParts[1]) - 1;
      var day = Number(formattedDateParts[0]);
      var cellDate = new Date(year, month, day);

      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      } else if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      } else {
        return 0;
      }
    },
  };

  // defining variables and setting the state
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [selectedRowsLength, setSelectedRowsLength] = useState(0);
  const [filterCount, setFilterCount] = useState(0);
  const [selectedRows, setSelectedRows] = useState(null);
  const [rowsData, setRowsData] = useState(null);

  // filters
  const options = [
    "CLEAN",
    "CLEAN - OCCUPIED",
    "DIRTY",
    "DIRTY - STAYOVER",
    "DIRTY - CHECKOUT",
    "OUT OF ORDER",
  ];

  const [filterValues, setFilterValues] = useState(options);
  // console.log(filters)

  // Date Picker and setting the properties on date change
  // Customised Calendar Filter
  // Handle date format
  const handleDate = (selectedDate) => {
    return moment(selectedDate).format("YYYY-MM-DD");
  };

  var date = new Date();
  const [datePicker, setDatePicker] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const HeaderCheckbox = (props) => {
    const { api, columnApi } = props;

    const handleHeaderCheckboxChange = (event) => {
      // Use forEachNodeAfterFilter to iterate over filtered rows
      api.forEachNodeAfterFilter((node) => {
        node.setSelected(event.target.checked);
      });
    };

    return (
      <label>
        <input
          type="checkbox"
          onChange={handleHeaderCheckboxChange}
          style={{
            marginRight: "18px",
            transform: "scale(1.2)",
          }}
        />
        Room No.
      </label>
    );
  };

  const [columns, setColumns] = useState([
    {
      field: "roomId",
      headerName: `${t("Room No.")}`,
      checkboxSelection: true,
      // headerCheckboxSelection: true,
      sortable: false,
      printWidth: "5%",
      dataType: "varchar",
      headerComponentFramework: HeaderCheckbox,

      // comparator: function (valueA, valueB, nodeA, nodeB, isDescending = true) {
      //   console.log("comparator values : ", valueA, valueB, nodeA, nodeB);
      //   return valueB - valueA;
      // },
      // sortingOrder: ["desc"],
    },
    {
      field: "status",
      headerName: `${t("Status")}`,
      sortable: false,
      dataType: "varchar",
      filter: true,
      cellRenderer: (params) => {
        const text = params.value?.toLowerCase();
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
    },
    {
      field: "customerName",
      headerName: `${t("Guest Name")}`,
      // hide:
      //   props?.data?.accessControl?.accessUser?.accessmap?.EnquiryDashboard ===
      //   undefined
      //     ? false
      //     : true,
      hide: false,
      dataType: "varchar",
      printWidth: "15%",
    },
    {
      field: "bookingStatus",
      headerName: `${t("Booking Status")}`,
      sortable: false,
      dataType: "varchar",
      printWidth: "7%",
      // hide:
      //   JSON.parse(
      //     props?.data?.accessControl?.user_feature_map?.EnquiryDashboard
      //   ).read !== "YES"
      //     ? true
      //     : false,
    },
    {
      field: "checkinDate",
      headerName: `${t("Check-in")}`,
      // hide: props?.hotelType?.toLowerCase() === "isha" ? false : true,
      hide: false,
      dataType: "date",
      dateFormat: "DD-MMM-YYYY hh A",
      printWidth: "8%",
      // filter: "agDateColumnFilter",
      // floatingFilterComponentParams: {
      //   suppressFilterButton: false,
      // },
      // filterParams: filterParams,
    },

    {
      field: "checkoutDate",
      headerName: `${t("Check-out")}`,
      // hide: props?.hotelType?.toLowerCase() === "isha" ? false : true,
      hide: false,
      dataType: "date",
      dateFormat: "DD-MMM-YYYY hh A",
      printWidth: "8%",
      // filter: "agDateColumnFilter",
      // floatingFilterComponentParams: {
      //   suppressFilterButton: true,
      // },
      // filterParams: filterParams,
    },
    {
      field: "currentHkStaffName",
      headerName: `${t("Staff Name")}`,
      // valueFormatter: (params) => params.value,
      // editable: true,
      printWidth: "8%",
    },
    {
      field: "staffRemark",
      headerName: `${t("Staff Remark")}`,
      // filter: "agNumberColumnFilter",
      editable: true,
      hide: false,
      dataType: "varchar",
    },
    {
      field: "bookingId",
      headerName: `${t("Booking ID")}`,
      valueFormatter: (params) => {
        return params.value.split("_")[2];
      },
      dataType: "varchar",
      printWidth: "5%",
      hide: false,
    },
    {
      field: "roomType",
      headerName: `${t("Type")}`,
      printWidth: "15%",
      dataType: "varchar",
      hide: true,
    },

    {
      field: "blockedReason",
      headerName: `${t("Blocked Reason")}`,
      hide: true,
      dataType: "varchar",
      printWidth: "5%",
    },
    {
      field: "ishaStatus",
      headerName: `${t("Isha Status")}`,
      sortable: false,
      dataType: "varchar",
      printWidth: "7%",
      hide:
        JSON.parse(
          props?.data?.accessControl?.user_feature_map?.EnquiryDashboard
        ).read !== "YES"
          ? true
          : false,
    },
    {
      field: "currentHkStaff",
      headerName: `${t("Staff Email")}`,
      // filter: "agNumberColumnFilter",
      // editable: true,
      printWidth: "8%",
      dataType: "varchar",
      hide: true,
    },
    {
      field: "admin",
      headerName: `${t("Supervisor")}`,
      // filter: "agNumberColumnFilter",
      editable: false,
      dataType: "varchar",
      printWidth: "8%",
      hide: true,
    },
    {
      field: "remark",
      headerName: `${t("Supervisor Remark")}`,
      // filter: "agNumberColumnFilter",
      editable: true,
      printWidth: "8%",
      dataType: "varchar",
      hide: true,
    },
  ]);

  useEffect(() => {
    if (props?.hotelType?.toLowerCase() !== "isha") {
      const data = columns.filter((item) => item.field !== "ishaStatus");
      setColumns(data);
    }
  }, []);

  const gridOptions = {
    readOnlyEdit: true,
    getRowId: (params) => params.data.id,
    pagination: true,
    rowSelection: "multiple",
    singleClickEdit: true,
  };

  // default column properties
  const defaultColDefs = {
    sortable: false, //sort the table
    floatingFilter: false, // getting the filter below the columns
    tooltipField: "name",
    filter: "agMultiColumnFilter", // setting the multi column filter for the table
    display: "subMenu", // how the text filter and the set filter will look like
    resizable: true,
  };

  // assigning the data to the grid api and calling the external API
  // on grid ready function
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  // Editing the cell value
  function onCellEditRequest(event) {
    const data = event.data;
    const field = event.colDef.field;
    const newValue = event.newValue;

    if (event?.column.colId === "remark") {
      setassignLoader(true);
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/hk/create-hk-admin`,
        {
          roomIdList: [event.data.roomId],
          admin: event.data.admin === null ? "" : event.data.admin,
          hotelId: hotelId,
          remark: event.data.remark,
          staffRemark:
            event.data.staffRemark === null ? "" : event.data.staffRemark,
          date: hkAdminDate,
        }
      )
        .then((res) => {
          toast.success(`${t("Successfully updated supervisor remarks")}`);
          getHkSummaryData();
          setSelectedRows([]);
          onCloseAdminModal();
          setRemark("");
          setstaffRemark("");
          getHkSummaryData();
          setassignLoader(false);
        })
        .catch((err) => {
          toast.error(err.response);
          setassignLoader(false);
          // onCloseAdminModal();
        });
    } else if (event?.column.colId === "staffRemark") {
      setassignLoader(true);
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/hk/create-hk-admin`,
        {
          roomIdList: [event.data.roomId],
          admin: event.data.admin === null ? "" : event.data.admin,
          hotelId: hotelId,
          staffRemark: event.data.staffRemark,
          date: hkAdminDate,
          remark: event.data.remark === null ? "" : event.data.remark,
        }
      )
        .then((res) => {
          toast.success(`${t("Successfully updated staff remarks")}`);
          getHkSummaryData();
          setSelectedRows([]);
          onCloseAdminModal();
          setRemark("");
          setstaffRemark("");
          getHkSummaryData();
          setassignLoader(false);
        })
        .catch((err) => {
          toast.error(err.response);
          setassignLoader(false);
          // onCloseAdminModal();
        });
    } else {
      setassignLoader(true);
      handleSpringDataMutationRequest(
        "POST",
        "core/api/v1/hk/change-staff-name",
        {
          staffId: field === "currentHkStaff" ? newValue : data.currentHkStaff,
          // staffId: data.roomId,
          staffName:
            field === "currentHkStaffName" ? newValue : data.currentHkStaffName,
        }
      )
        .then((res) => {
          setassignLoader(false);
          getHkSummaryData();
        })
        .catch((err) => {
          toast.error(
            "Error in changing the staff details. Please try again later!"
          );
          setassignLoader(false);
        });
    }
  }

  const handleBulkStaffRemark = () => {
    setassignLoader(true);
    for (let i = 0; i < selectedRows.length; i++) {
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/hk/create-hk-admin`,
        {
          roomIdList: [selectedRows[i].roomId],
          admin: selectedRows[i].admin,
          hotelId: hotelId,
          remark: selectedRows[i].remark,
          staffRemark: staffRemark,
          date: hkAdminDate,
        }
      )
        .then((res) => {
          toast.success("Successfully updated staff remarks");
          setassignLoader(false);
        })
        .catch((err) => {
          toast.error(err.response);
          setassignLoader(false);
          // onCloseStaffModal();
        });
    }
    getHkSummaryData();
    setSelectedRows([]);
    setRemark("");
    setstaffRemark("");
    onCloseStaffModal();
  };

  useEffect(() => {
    const date = moment(pickDate).format("YYYY-MM-DD");
    const myMomentObject = moment(date, "YYYY-MM-DD");
    sethkAdminDate(myMomentObject.unix());
  }, [pickDate]);

  // Storing the summary
  const [summary, setSummary] = useState(null);

  // returning the payload based on the valued received
  const analyticalValues = [
    {
      name: "clean",
      formattedName: `${t("CLEAN")}`,
      color: "#1AB394",
    },
    {
      name: "cleanOccupied",
      formattedName: `${t("CLEAN OCCUPIED")}`,
      color: "#1AB394",
    },
    {
      name: "dirty",
      formattedName: `${t("DIRTY")}`,
      color: "#ED5565",
    },
    {
      name: "dirtyCheckout",
      formattedName: `${t("DIRTY CHECKOUT")}`,
      color: "#ED5565",
    },
    {
      name: "dirtyStayover",
      formattedName: `${t("DIRTY STAYOVER")}`,
      color: "#ED5565",
    },
    {
      name: "outOfOrder",
      formattedName: `${t("OUT OF ORDER")}`,
      color: "#DEB16A",
    },
    {
      name: "totalClean",
      formattedName: `${t("TOTAL CLEAN")}`,
      color: "#1AB394",
    },
    {
      name: "totalDirty",
      formattedName: `${t("TOTAL DIRTY")}`,
      color: "#ED5565",
    },
  ];

  const handleFormattedAnalyticalName = (name) =>
    analyticalValues
      .filter((items) => items.name === name)
      .map((item) => {
        return item.formattedName;
      });

  const handleColor = (name) =>
    analyticalValues
      .filter((items) => items.name === name)
      .map((item) => {
        return item.color;
      });

  // calling the summary data
  const getHkSummaryData = () => {
    setloader(true);
    setRowsData(null);

    if (
      subUser?.toLowerCase() === "subuser" &&
      JSON.parse(props?.data?.accessControl?.user_feature_map?.HKStaff).read ===
        "YES"
    ) {
      handleSpringDataRequest(
        `core/api/v1/hk/get-housekeeping-report-with-summary?date=${moment(
          `${pickDate}`
        ).format("DD-MM-yyyy")}&staffEmail=${loggedInemail}`
      ).then((res) => {
        setRowsData(res.reportFormatList);
        setSummary(res.summaryReport);
        setloader(false);
      });
    } else if (
      subUser?.toLowerCase() === "subuser" &&
      JSON.parse(props?.data?.accessControl?.user_feature_map?.HKSupervisor)
        .read === "YES"
    ) {
      handleSpringDataRequest(
        `core/api/v1/hk/get-housekeeping-report-with-summary?date=${moment(
          `${pickDate}`
        ).format("DD-MM-yyyy")}&supervisorEmail=${loggedInemail}`
      ).then((res) => {
        setRowsData(res.reportFormatList);
        setSummary(res.summaryReport);
        setloader(false);
      });
    } else {
      handleSpringDataRequest(
        `core/api/v1/hk/get-housekeeping-report-with-summary?date=${moment(
          `${pickDate}`
        ).format("DD-MM-yyyy")}`
      ).then((res) => {
        setRowsData(res.reportFormatList);
        setSummary(res.summaryReport);
        setloader(false);
      });
    }

    // .then((res) => {
    //   res.reportFormatList.map(
    //     (item) =>
    //       filterValues.includes(item.status) &&
    //       setProducts((product) => [...product, item])
    //   );
    // });
  };

  const [loader, setloader] = useState(false);
  // useEffect(() => {
  //   if (
  //     loggedInemail !== null &&
  //     loggedInemail !== undefined &&
  //     loggedInemail !== ""
  //   ) {
  //     setloader(true);
  //     getHkSummaryData();
  //     setloader(false);
  //   }
  // }, [filterValues, loggedInemail, subUser]);

  // post operations
  // handle bulk dirty
  // Opening modal for staff assignment while marking the room dirty
  const [openDirty, setOpenDirty] = useState(false);
  const onOpenDirtyModal = () => setOpenDirty(true);
  const onCloseDirtyModal = () => setOpenDirty(false);
  //Assign unassign
  const [openAssign, setOpenAssign] = useState(false);
  const [openUnassign, setOpenUnassign] = useState(false);

  // Opening modal for staff assignment while marking the room dirty
  const [openAdminModal, setopenAdminModal] = useState(false);
  const onopenAdminModal = () => setopenAdminModal(true);
  const onCloseAdminModal = () => setopenAdminModal(false);

  // Opening modal for staff assignment while marking the room dirty
  const [openStaffModal, setopenStaffModal] = useState(false);
  const onopenStaffModal = () => setopenStaffModal(true);
  const onCloseStaffModal = () => setopenStaffModal(false);

  //open clean modal
  const [openClean, setOpenClean] = useState(false);
  const onOpenCleanModal = () => setOpenClean(true);
  const onCloseCleanModal = () => setOpenClean(false);

  // Getting all the staff list

  const [staffData, setStaffData] = useState([]);
  const [selectedStaff, setselectedStaff] = useState("");

  const getAllData = async () => {
    try {
      const data = await getAllStaffsData();
      setStaffData(data);
      setselectedStaff(data[0].email);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(async () => {
    await getAllData();
  }, []);

  // Handle assigning the staff
  const [staffVal, setStaffVal] = useState({
    selectedStaffName: "",
    selectedStaffId: "",
  });

  // Changing the staff status
  const handleStaffChange = (event, val) => {
    setStaffVal({
      ...staffVal,
      selectedStaffName: val.props.name,
      selectedStaffId: event.target.value,
    });
  };

  // Bulk dirty loader
  const [bulkDirtyLoader, setBulkDirtyLoader] = useState(false);

  useEffect(() => {
    setDateEqual(
      moment(pickDate).format("DD-MM-YYYY") ===
        moment(new Date()).format("DD-MM-YYYY")
    );
  }, [pickDate]);

  // const handleBulkDirty = () => {
  //   setloader(true);
  //   setBulkDirtyLoader(true);
  //   handleSpringDataMutationRequest(
  //     "POST",
  //     `core/api/v1/hk/bulk-mark-rooms-dirty`,
  //     {
  //       roomIds: selectedRoomId,
  //       staffId: staffVal?.selectedStaffId,
  //       hotelId: hotelId,
  //     }
  //   )
  //     .then((res) => {
  //       {
  //         DateEqual && toast.success("Successfully marked Dirty");
  //       }
  //       setloader(false);
  //       setBulkDirtyLoader(false);
  //       getHkSummaryData();
  //       setSelectedRows([]);
  //       onCloseDirtyModal(true);
  //     })
  //     .catch((err) => toast.error(err.response));

  //   if (!DateEqual) {
  //     handleSpringDataMutationRequest(
  //       "POST",
  //       `core/api/v1/hk/create-future-hk-staff-email`,
  //       {
  //         staffEmail: staffVal?.selectedStaffId,
  //         roomIdList: selectedRoomId,
  //         hotelId: hotelId,
  //         date: hkAdminDate,
  //       }
  //     )
  //       .then((res) => {
  //         toast.success("Successfully room assigned");
  //         setloader(false);
  //         setBulkDirtyLoader(false);
  //         getHkSummaryData();
  //         setSelectedRows([]);
  //         onCloseDirtyModal(true);
  //       })
  //       .catch((err) => toast.error(err.response));
  //   }
  // };

  const FutureAssignment = () => {
    if (!DateEqual) {
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/hk/create-future-hk-staff-email`,
        {
          staffEmail: staffVal?.selectedStaffId,
          roomIdList: selectedRoomId,
          hotelId: hotelId,
          date: hkAdminDate,
        }
      )
        .then((res) => {
          // toast.success("Successfully room assigned");
          setloader(false);
          setBulkDirtyLoader(false);
          getHkSummaryData();
          setSelectedRows([]);
          onCloseDirtyModal(true);
        })
        .catch((err) => {
          // toast.error(err.response)
          console.log(err);
        });
    }
  };
  const handleBulkDirty = () => {
    setBulkDirtyLoader(true);
    axios
      .post(
        `${process.env.REACT_APP_BG_API_URL}core/api/v1/hk/bulk-mark-rooms-dirty`,
        {
          roomIds: selectedRoomId,
          staffId: "",
          hotelId: hotelId,
        }
      )
      .then((res) => {
        toast.success(`${t("Successfully marked Dirty")}`);
        setBulkDirtyLoader(false);
        getHkSummaryData();
        setSelectedRows([]);
        onCloseDirtyModal(true);
        FutureAssignment();
      })
      .catch((err) => {
        toast.error(err.response);
        setBulkDirtyLoader(false);
      });
  };
  const handleBulkAssignDirty = () => {
    setBulkDirtyLoader(true);

    axios
      .post(
        `${process.env.REACT_APP_BG_API_URL}core/api/v1/hk/bulk-mark-rooms-dirty`,
        {
          roomIds: selectedRoomId,
          staffId: staffVal?.selectedStaffId,
          hotelId: hotelId,
        }
      )
      .then((res) => {
        toast.success(`${t("Successfully room assigned")}`);
        setBulkDirtyLoader(false);
        getHkSummaryData();
        setSelectedRows([]);
        setOpenAssign(false);
        FutureAssignment();
      })
      .catch((err) => {
        toast.error(err.response);
        setBulkDirtyLoader(false);
      });
  };
  const handleBulkUnassign = () => {
    setBulkDirtyLoader(true);

    axios
      .post(
        `${process.env.REACT_APP_BG_API_URL}core/api/v1/hk/bulk-mark-rooms-dirty`,
        {
          roomIds: selectedRoomId,
          staffId: "",
          hotelId: hotelId,
        }
      )
      .then((res) => {
        toast.success(`${t("Successfully room unassigned")}`);
        setBulkDirtyLoader(false);
        getHkSummaryData();
        setSelectedRows([]);
        setOpenUnassign(false);
        // FutureAssignment();
      })
      .catch((err) => {
        toast.error(err.response);
        setBulkDirtyLoader(false);
      });
  };
  const [assignLoader, setassignLoader] = useState(false);
  const handleBulkAssignment = () => {
    setassignLoader(true);
    handleSpringDataMutationRequest("POST", `core/api/v1/hk/create-hk-admin`, {
      roomIdList: selectedRoomId,
      admin: staffVal?.selectedStaffId,
      hotelId: hotelId,
      remark: remark,
      date: hkAdminDate,
      staffRemark: staffRemark,
    })
      .then((res) => {
        toast.success(`${t("Successfully updated staff remarks")}`);
        getHkSummaryData();
        setSelectedRows([]);
        onCloseAdminModal();
        setRemark("");
        setstaffRemark("");
        setassignLoader(false);
      })
      .catch((err) => {
        toast.error(err.response);
        setassignLoader(false);
        // onCloseAdminModal();
      });
  };

  // handle bulk clean
  const handleBulkClean = () => {
    setloader(true);
    axios
      .post(
        `${process.env.REACT_APP_BG_API_URL}core/api/v1/hk/bulk-mark-rooms-clean?${hotelId}`,
        {
          roomIds: selectedRoomId,
          staffId: "",
        }
      )
      .then((res) => {
        toast.success(`${t("Successfully marked Clean")}`);
        setloader(false);
        getHkSummaryData();
        setSelectedRows([]);
        onCloseCleanModal();
      })
      // .then(async () => {
      //   const payload = [
      //     {
      //       physicalRoomIds: selectedRoomId,
      //       startDate: moment(pickDate).format("DD-MM-YYYY HH:MM:SS"),
      //       endDate: moment(pickDate).format("DD-MM-YYYY HH:MM:SS"),
      //       datesText:
      //         "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday",
      //       id: `${pickDate} - ${pickDate}Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday`,
      //       text: "",
      //       reason: "",
      //     },
      //   ];
      //   const res = await unBlockMultipleRooms(payload);
      // })
      .catch((err) => {
        toast.error(err.response);
        setloader(false);
      });
  };

  const todayDate = new Date();
  // handle bulk out of order
  const [open, setOpen] = useState(false);

  const [oooDate, setOOODate] = useState([todayDate, todayDate]);
  const [oooStartDate, setOOOStartDate] = useState(todayDate);
  const [oooEndDate, setOOOEndDate] = useState(todayDate);
  const [reason, setReason] = useState("");
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => {
    setOpen(false);
    getHkSummaryData();
    setReason("");
  };
  const handleBulkOutOfOrder = () => {
    setloader(true);
    bulkMarkAvailable === 0
      ? handleSpringDataMutationRequest("POST", `core/api/v1/room/blockRooms`, {
          endDate: moment(`${oooEndDate}`).format("DD-MM-yyyy HH:mm:ss"),
          physicalRoomIds: selectedRoomId,
          reason: reason,
          startDate: moment(`${oooStartDate}`).format("DD-MM-yyyy HH:mm:ss"),
        })
          .then((res) => {
            toast.success(`${t("Successfully marked as out of order")}`);
            getHkSummaryData();
            setloader(false);
            onCloseModal();
            setReason("");
          })
          .catch((err) => {
            toast.error(err.response.data);
            setloader(false);
          })
      : handleSpringDataMutationRequest(
          "POST",
          `core/api/v1/room/unblock-multiple-rooms`,
          [
            {
              endDate: moment(`${oooEndDate}`).format("DD-MM-yyyy 00:00:00"),
              physicalRoomIds: selectedRoomId,
              reason: reason,
              startDate: moment(`${oooStartDate}`).format(
                "DD-MM-yyyy 00:00:00"
              ),
            },
          ]
        )
          .then((res) => {
            toast.success("Successfully marked as available1");
            getHkSummaryData();
            setloader(false);
            onCloseModal();
            setReason("");
          })
          .catch((err) => {
            toast.error(err.response.data);
            setloader(false);
          });
  };

  // Calling the grid api and then exporting the data into the csv format
  const onExportClick = () => {
    selectedRowsLength === 0
      ? gridApi.exportDataAsCsv()
      : gridApi.exportDataAsCsv({ onlySelected: true });
  };

  //  Exporting it in the Excel format
  const onExportExcel = () => {
    selectedRowsLength === 0
      ? gridApi.exportDataAsExcel()
      : gridApi.exportDataAsExcel({ onlySelected: true });
  };

  // Open PDF Modal
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const onOpenPdfModal = () => setOpenPdfModal(true);
  const onClosePdfModal = () => setOpenPdfModal(false);

  // const getDownloadType = (dType) => {
  //   dType === "1" && onExportClick();
  //   dType === "2" && renderCustomReportPdf();
  //   dType === "3" && onExportExcel();
  // };

  // Click away listener for download options
  const [openDownloadType, setOpenDownloadType] = useState(false);
  const handleOpenDownloadType = () => {
    setOpenDownloadType((prev) => !prev);
  };

  const handleClickAwayDownloadType = () => {
    setOpenDownloadType(false);
  };
  // actions dropdown
  const [openActions, setOpenActions] = useState(false);

  const rowSelectionType = "multiple";

  /* SELECTED BOOKING ID */
  // using the booking id
  const [selectedRoomId, setSelectedRoomId] = useState(null);

  // On selection of a row get its data
  const onSelectionChanged = (event) => {
    setSelectedRowsLength(event.api.getSelectedRows().length);
    setSelectedRows(event.api.getSelectedRows());
  };

  // Get the selected room id
  const getSelectedRoomIds = () =>
    setSelectedRoomId(selectedRows?.map((item) => item.roomId));

  useEffect(() => {
    getSelectedRoomIds();
  }, [selectedRows]);

  // dynamically change the page size
  const onPaginationChange = (pageSize) => {
    gridApi.paginationSetPageSize(pageSize);
  };

  // quick search
  const onFilterTextChange = (event) => {
    // console.log(event.target.value)
    setFilterCount((prevCount) => prevCount + 1);
    // console.log("filterCount", filterCount)
    gridApi.setQuickFilter(event.target.value);
  };
  //quick filter
  const [selectedCard, setSelectedCard] = useState("");

  const handelFilter = (elm) => {
    setSelectedCard(elm);
    gridApi.setFilterModel(null);
    if (elm === "TOTAL DIRTY") {
      gridApi.setQuickFilter("DIRTY");
    } else if (elm === "TOTAL CLEAN") {
      gridApi.setQuickFilter("CLEAN");
    } else if (elm === "DIRTY") {
      // const gFilterModel = gridApi.getFilterModel();
      gridApi.setFilterModel({
        status: {
          filterType: "set",
          values: ["DIRTY"], // ✅ CORRECT
        },
      });
      gridApi.setQuickFilter(null);
    } else if (elm === "CLEAN") {
      // const gFilterModel = gridApi.getFilterModel();
      gridApi.setFilterModel({
        status: {
          filterType: "set",
          values: ["CLEAN"], // ✅ CORRECT
        },
      });
      gridApi.setQuickFilter(null);
    } else {
      gridApi.setQuickFilter(elm);
    }

    gridApi.deselectAll();
  };

  // Managing state for bulk mark out of order and bulk mark available
  const [bulkMarkAvailable, setBulkMarkAvailable] = useState(0);

  const [rooms, setRooms] = useState(null);

  const getAllRooms = async () => {
    try {
      const data = await getAllNonHiddenRoomTypes();

      setRooms(Object.entries(data));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(async () => {
    await getAllRooms();
  }, []);

  const getRoomId = (roomType) => {
    const mydata = rooms?.filter((e) => e[1] === roomType);
    return mydata[0][0];
  };

  const [loaders, setloaders] = useState(false);
  const updateTheStaff = () => {
    for (let i = 0; i < selectedRows?.length; i++) {
      setloaders(true);
      const payload = {
        roomIds: [selectedRows[i].roomId],
        roomTypeId: getRoomId(selectedRows[i].roomType),
        staffId: selectedStaff,
        staffName: selectedStaff,
      };
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/hk/assign-rooms-to-staff`,
        payload
      )
        .then((res) => setloaders(false))
        .catch((err) => setloaders(false));
    }
    getHkSummaryData();
  };

  function onSaveGridColumnState() {
    if (!gridColumnApi) return;
    let columnState = gridColumnApi?.getColumnState();
    sessionStorage.setItem("hkCharterTable", JSON.stringify(columnState));
    for (let i = 0; i < columns.length; i++) {
      const updatedState = columnState.filter(
        (item) => item.colId === columns[i]["field"]
      );
      columns[i]["hide"] = updatedState[0]?.hide;
      columns[i]["sort"] = updatedState[0]?.sort;
    }
    sessionStorage.setItem("hkCharterColumn", JSON.stringify(columns));
    // debounceSaveGridColumnState(props.id, columnState);
  }

  function onFirsDataRendered() {
    let columnState = JSON.parse(sessionStorage.getItem("hkCharterTable"));
    if (columnState) {
      return gridColumnApi?.applyColumnState({
        state: columnState,
        applyOrder: true,
      });
    }
  }

  // Function to update the row data on filter changed
  let [updatedRowsData, setUpdatedRowsData] = useState(rowsData);
  useEffect(() => {
    setUpdatedRowsData(rowsData);
  }, [rowsData]);
  function updateRowData() {
    let updatedData = [];
    gridApi.forEachNodeAfterFilterAndSort((i) => {
      updatedData.push(i.data);
    });
    return setUpdatedRowsData(updatedData);
  }

  // Getting the hotel logo
  const [hotelLogo, setHotelLogo] = useState(null);
  const getHotelLogo = () => {
    handleSpringDataRequest("core/api/v1/image/get-hotel-base64-logo/")
      .then((res) => setHotelLogo(res))
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getHotelLogo();
  }, []);

  return (
    <Stack
      spacing={2}
      className="houseKeepingCharterTable"
      style={{ height: "100%", overflow: "scroll", paddingTop: "20px" }}
    >
      <Stack direction={"row"} spacing={2} px={1}>
        {summary &&
          Object.entries(summary).map(([key, val]) => (
            <Box
              sx={{
                flex: 1,
                height: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <HouseKeepingAnalytics2
                analyticsName={handleFormattedAnalyticalName(key)}
                analyticsValue={val}
                bgColor={handleColor(key)}
                handelFilter={handelFilter}
                selectedCard={selectedCard}
              />
            </Box>
          ))}
        {summary && (
          <Box
            sx={{
              flex: 1,
              height: "100px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <HouseKeepingAnalytics2
              analyticsName={[]}
              analyticsValue={rowsData?.length}
              bgColor={"#1AB394"}
              handelFilter={handelFilter}
              selectedCard={selectedCard}
              selectedLanguage={[props.selectedLanguage]}
            />
          </Box>
        )}
      </Stack>
      <div className="nameHeaderWrapper">
        <div className="headerOptions">
          <Stack direction="row">
            <div className="searchFunctionality">
              <input
                className="searchInp"
                type="search"
                onChange={onFilterTextChange}
                placeholder={t("Search...")}
              />
            </div>
            <div className="paginationWrapper">
              <select
                className="paginationSelection"
                onChange={(e) => onPaginationChange(e.target.value)}
              >
                <option value="100">100</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div className="datePicker">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label={t("Pick your date")}
                  // inputFormat="MM/dd/yyyy"
                  inputFormat="dd MMM yyyy"
                  value={pickDate}
                  onChange={handleChange}
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </LocalizationProvider>
            </div>

            {/* <div className="roomTypeFilter">
              <Autocomplete
                multiple
                // id="checkboxes-tags-demo"
                id="multiple-limit-tags"
                limitTags={3}
                style={{ height:"35px" }}
                options={options}
                disableCloseOnSelect
                getOptionLabel={(option) => option}
                defaultValue={options.map((filter) => filter)}
                onChange={(event, newValue) => {
                  setFilterValues(newValue);
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                // style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField {...params} label="Filters" size="small" />
                )}
              />
            </div> */}
            <div className="exportWrapper">
              <ClickAwayListener
                onClickAway={() => {
                  setOpenActions(false);
                }}
              >
                <Box sx={{ position: "relative", width: "400%" }}>
                  <button
                    type="button"
                    className="downloadTypeBtn"
                    onClick={() => setOpenActions((prev) => !prev)}
                  >
                    {t("Actions")}
                    {openActions ? (
                      <RiIcons.RiArrowUpSLine />
                    ) : (
                      <RiIcons.RiArrowDownSLine />
                    )}
                  </button>
                  {openActions ? (
                    <Box sx={styles}>
                      {moment(pickDate).format("DD-MM-YYYY") ===
                        moment(new Date()).format("DD-MM-YYYY") && (
                        <Typography
                          className="exportOption"
                          onClick={onOpenCleanModal}
                        >
                          {" "}
                          {t("Mark Clean")}
                        </Typography>
                      )}
                      <Typography
                        className="exportOption"
                        onClick={onOpenDirtyModal}
                      >
                        {t("Mark Dirty")}
                      </Typography>
                      <Typography
                        className="exportOption"
                        onClick={() => setOpenAssign(true)}
                      >
                        {t("Mark assign staff for cleaning room")}
                      </Typography>
                      {/* <Typography
                        className="exportOption"
                        onClick={() => setOpenUnassign(true)}
                      >
                        Mark unssign staff from room
                      </Typography> */}
                      {(props?.data?.accessControl?.ADMINRIGHTS === "ADMIN" ||
                        props?.data?.accessControl?.ADMINRIGHTS ===
                          "SUBADMIN" ||
                        JSON.parse(
                          props?.data?.accessControl?.user_feature_map
                            ?.HideBlockRooms
                        ).read !== "YES" ||
                        (props?.hotelType?.toLowerCase() !== "isha" &&
                          subUser?.toLowerCase() === "subuser")) && (
                        <Typography
                          className="exportOption"
                          onClick={() => {
                            onOpenModal();
                            setBulkMarkAvailable(0);
                          }}
                        >
                          {" "}
                          {t("Mark Out Of Order")}{" "}
                        </Typography>
                      )}
                      {(props?.data?.accessControl?.ADMINRIGHTS === "ADMIN" ||
                        props?.data?.accessControl?.ADMINRIGHTS ===
                          "SUBADMIN" ||
                        JSON.parse(
                          props?.data?.accessControl?.user_feature_map
                            ?.HideUnBlockRooms
                        ).read !== "YES" ||
                        (props?.hotelType?.toLowerCase() !== "isha" &&
                          subUser?.toLowerCase() === "subuser")) && (
                        <Typography
                          className="exportOption"
                          onClick={() => {
                            onOpenModal();
                            setBulkMarkAvailable(1);
                          }}
                        >
                          {" "}
                          {t("Mark 'Available' for out-of-order rooms")}
                        </Typography>
                      )}
                      {props?.hotelType?.toLowerCase() === "isha" &&
                        subUser?.toLowerCase() !== "subuser" && (
                          <Typography
                            className="exportOption"
                            onClick={() => {
                              onopenAdminModal();
                              setBulkMarkAvailable(0);
                            }}
                          >
                            {" "}
                            {t("Assign room to supervisor and add remark")}{" "}
                          </Typography>
                        )}
                      {props?.hotelType?.toLowerCase() !== "isha" && (
                        <Typography
                          className="exportOption"
                          onClick={() => {
                            onopenAdminModal();
                            setBulkMarkAvailable(0);
                          }}
                        >
                          {" "}
                          {t("Assign room to supervisor and add remark")}{" "}
                        </Typography>
                      )}
                      <Typography
                        className="exportOption"
                        onClick={() => {
                          onopenStaffModal();
                          setBulkMarkAvailable(0);
                        }}
                      >
                        {" "}
                        {t("Add staff remark")}{" "}
                      </Typography>
                    </Box>
                  ) : null}
                </Box>
              </ClickAwayListener>
            </div>

            <div className="exportWrapper">
              {/* <BsIcons.BsDownload size="17" color="black" /> */}
              {/* <select
                value="0"
                className="exportOptionsWrapper"
                onChange={(e) => getDownloadType(e.target.value)}
              >
                <option value="0" selected>
                  Export As...
                </option>
                <option value="1">Export as CSV</option>
                <option value="2">Export as PDF</option>
                <option value="3">Export as Excel</option>
                <div>{renderCustomReportPdf()}</div>
              </select> */}
              <ClickAwayListener onClickAway={handleClickAwayDownloadType}>
                <Box sx={{ position: "relative" }}>
                  <button
                    type="button"
                    className="downloadTypeBtn"
                    onClick={handleOpenDownloadType}
                  >
                    {t("Export report")}{" "}
                    {openDownloadType ? (
                      <RiIcons.RiArrowUpSLine />
                    ) : (
                      <RiIcons.RiArrowDownSLine />
                    )}
                  </button>
                  {openDownloadType ? (
                    <Box sx={styles}>
                      <Typography
                        onClick={() => onExportClick()}
                        className="exportOption"
                      >
                        {t("Export as CSV")}
                      </Typography>
                      <Typography className="exportOption">
                        <CustomReportPdf
                          reportColumns={columns}
                          reportData={
                            selectedRowsLength > 0
                              ? selectedRows
                              : updatedRowsData
                          }
                          reportName={"Housekeeping charter"}
                          dateRange={{
                            startDate: oooStartDate,
                            endDate: oooEndDate,
                          }}
                          hotelLogo={hotelLogo}
                        />
                      </Typography>
                      <Typography
                        onClick={() => onExportExcel()}
                        className="exportOption"
                      >
                        {t("Export as Excel")}
                      </Typography>
                    </Box>
                  ) : null}
                </Box>
              </ClickAwayListener>
            </div>

            <Tooltip
              title={t(
                "This charter is useful when you want to see the status of a room on day to day basis. Also, it will give the overall room status i.e Clean, Clean Occupied, Dirty, Dirty-Stayover, Dirty Check-out, Out of Order, of housekeeping. This page helps you in assigning staff to a particular page and adding remarks so that team can coordinate accordingly."
              )}
            >
              <IconButton className="ml-2">
                <InfoIcon />
              </IconButton>
            </Tooltip>
            {/* <div style={{ height: "1rem" }}>
              <FormControl sx={{ width: "14rem" }}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  Select Staff
                </InputLabel>
                <Select
                  value={selectedStaff}
                  onChange={(e) => setselectedStaff(e.target.value)}
                  id="controllable-states-demo"
                  labelId="demo-simple-select-autowidth-label"
                  sx={{ width: "14rem" }}
                  input={<OutlinedInput label="Select Staff" />}
                >
                  {staffData?.map((item, index) => (
                    <MenuItem key={index} name={item.email} value={item.email}>
                      {item.email}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div> */}
            {/* <div>
              <Button
                variant="custom-button"
                onClick={updateTheStaff}
                disabled={loaders}
                style={{ marginLeft: "1rem", heigth: "3rem", marginTop: "3px" }}
              >
                {loaders ? (
                  <CircularProgress
                    size={15}
                    color="inherit"
                    sx={{ ml: 1.5 }}
                  />
                ) : (
                  "Assign staff"
                )}
              </Button>
            </div> */}
          </Stack>
        </div>
        {/* </div> */}
        <div className="agTable">
          <div className="ag-theme-alpine">
            {rowsData ? (
              <AgGridReact
                onFirstDataRendered={onFirsDataRendered}
                onColumnVisible={onSaveGridColumnState}
                onFilterChanged={updateRowData}
                className="agGridTable"
                rowData={rowsData}
                onGridReady={onGridReady}
                columnDefs={columns}
                defaultColDef={defaultColDefs}
                enableBrowserTooltips={true}
                onSelectionChanged={onSelectionChanged}
                rowMultiSelectWithClick={true}
                paginationPageSize={100}
                alwaysShowBothConditions={true}
                rowSelection={rowSelectionType}
                onCellEditingStopped={onCellEditRequest}
                rowHeight={48}
                headerHeight={56}
                // groupIncludeTotalFooter = {true}
                sideBar={{
                  toolPanels: [
                    {
                      id: "columns",
                      labelDefault: "Columns",
                      labelKey: "columns",
                      iconKey: "columns",
                      toolPanel: "agColumnsToolPanel",
                    },
                  ],
                  defaultToolPanel: "none",
                }}
                groupMultiAutoColumn={true}
                suppressAggFuncInHeader={true}
                // groupRowAggNodes = {getTotalValue}
                // suppressAggFilteredOnly = {true}
                // getRowNodeId= {getRowNodeId}
                statusBar={{
                  statusPanels: [
                    {
                      statusPanel: "agTotalAndFilteredRowCountComponent",
                      align: "left",
                    },
                    {
                      statusPanel: "agTotalRowCountComponent",
                      align: "center",
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" },
                  ],
                }}
                gridOptions={gridOptions}
              />
            ) : (
              <MockLoaderTable />
            )}
          </div>
        </div>
      </div>

      {/* bulk mark out of order modal */}
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay",
          modal: "customOOOModal",
        }}
      >
        <div className="bulkMarkOOOWrapper">
          <div className="oooHeader">
            {bulkMarkAvailable === 0
              ? `${t("Bulk mark out of order")}`
              : `${t("Bulk mark available")}`}
          </div>
          <div className="separator" />
          <div className="selectedRoomIds">
            {selectedRoomId?.length > 0 ? (
              <Autocomplete
                multiple
                limitTags={3}
                id="multiple-limit-tags"
                fullWidth
                options={selectedRoomId}
                getOptionLabel={(option) => option}
                defaultValue={selectedRoomId.map((item) => item)}
                onChange={(event, newValue) => {
                  setSelectedRoomId(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("Selected Rows")}
                    placeholder=""
                    // sx={{ width: "35px" }}
                  />
                )}
                // style={{ width: 600 }}
              />
            ) : (
              <Typography align="center">{t("No rows selected")}</Typography>
            )}
          </div>
          {/* <div className="inpWrapper"> */}
          <div
            className="dateRange mt-4"
            style={{
              position: "relative",
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {/* <DatePicker
                  label="Start date"
                  value={oooStartDate}
                  onChange={(newValue) => {
                    setOOOStartDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      helperText="MM/DD/YYYY"
                      style={{ marginRight: "2.5px" }}
                    />
                  )}
                /> */}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label={t("Start date")}
                // inputFormat="dd-MM-yyyy"
                inputFormat="dd MMM yyyy"
                value={oooStartDate}
                onChange={(newValue) => {
                  setOOOStartDate(newValue);
                  setOOOEndDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    helperText="DD-MM-YYYY"
                    style={{ marginRight: "2.5px" }}
                  />
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label={t("End date")}
                // inputFormat="dd-MM-yyyy"
                inputFormat="dd MMM yyyy"
                value={oooEndDate}
                onChange={(newValue) => {
                  setOOOEndDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    helperText="DD-MM-YYYY"
                    style={{ marginRight: "2.5px" }}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          {oooEndDate - oooStartDate < 0 && (
            <Typography align="center" sx={{ color: "red", mt: 1, mb: 1 }}>
              {t("End date can not be less than start date")}
            </Typography>
          )}
          <div className="reasonWrapper mt-5">
            <TextField
              id="outlined-multiline-flexible"
              label={t("Reason")}
              multiline
              maxRows={4}
              value={reason}
              onChange={handleReasonChange}
              className="reasonField"
              fullWidth
            />
          </div>
          {/* </div> */}
          <div className="oooButtonWrapper">
            <button className="cancelBtn" onClick={onCloseModal}>
              {t("Cancel")}
            </button>
            <Button
              variant="custom-button"
              onClick={handleBulkOutOfOrder}
              disabled={
                !selectedRoomId?.length > 0 ||
                loader ||
                oooEndDate - oooStartDate < 0
              }
            >
              {t("Submit")} {loader && <CircularProgress size="15px" />}
            </Button>
            {/* {loader === false ? (
              <button
                className="submitBtn"
                onClick={handleBulkOutOfOrder}
                disabled={!selectedRoomId?.length > 0}
              >
                Submit
              </button>
            ) : (
              <button className="submitBtn">
                <CircularProgress size="15px" />
              </button>
            )} */}
          </div>
        </div>
      </Modal>

      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openPdfModal}
        onClose={onClosePdfModal}
        center
      >
        <div className="pdfExportWrapper">
          <PDFExportPanel
            gridApi={gridApi}
            columnApi={gridColumnApi}
            report_Type={reportType}
            startdate={moment(pickDate).format("MMM DD YYYY")}
            enddate={moment(pickDate).format("MMM DD YYYY")}
            housekeepingReport={true}
            selectedLanguage={props.selectedLanguage}
            // numEnteries={numEnteries}
            // selectedNumEnteries={selectedNumEnteries}
          />
        </div>
      </Modal>

      {/* Opening modal while marking the rooms bulk dirty and assigning staff */}
      {/* <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openDirty}
        onClose={onCloseDirtyModal}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            {DateEqual
              ? `Bulk Mark Dirty / Assign staff for cleaning room`
              : `Assign staff for cleaning room`}
          </div>
          {selectedRoomId?.length > 0 ? (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{ marginTop: "auto", marginBottom: "auto" }}
              >
                Selected room Ids:
              </div>
              <div
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {selectedRoomId.map((item) => (
                  <div style={{ marginLeft: "5px" }}>
                    <Chip label={item} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Typography align="center">No rows selected</Typography>
          )}
          <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-autowidth-label">
              Select Staff
            </InputLabel>
            <Select
              value={staffVal.selectedStaffName}
              onChange={handleStaffChange}
              id="controllable-states-demo"
              labelId="demo-simple-select-autowidth-label"
              sx={{ width: 500 }}
              input={<OutlinedInput label="Select Staff" />}
            >
              {staffData?.map((item, index) => (
                <MenuItem key={index} name={item.email} value={item.email}>
                  {item.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
            }}
          >
            <Button variant="secondary" onClick={onCloseDirtyModal}>
              Close
            </Button>
            <Button
              variant="custom-button"
              onClick={handleBulkDirty}
              disabled={!selectedRoomId?.length > 0}
            >
              {!bulkDirtyLoader ? "Save" : <CircularProgress size="15px" />}
            </Button>
          </div>
        </div>
      </Modal> */}
      {/* Opening modal while marking the rooms bulk dirty  */}
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openDirty}
        onClose={onCloseDirtyModal}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            {t("Bulk Mark Dirty")}
          </div>
          {selectedRoomId?.length > 0 ? (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{ marginTop: "auto", marginBottom: "auto" }}
              >
                {t("Selected room Ids:")}
              </div>
              <div
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {selectedRoomId.map((item) => (
                  <div style={{ marginLeft: "5px" }}>
                    <Chip label={item} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Typography align="center">{t("No rows selected")}</Typography>
          )}

          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
            }}
          >
            <Button variant="secondary" onClick={onCloseDirtyModal}>
              {t("Close")}
            </Button>
            <Button
              variant="custom-button"
              onClick={handleBulkDirty}
              disabled={!selectedRoomId?.length > 0}
            >
              {!bulkDirtyLoader ? (
                `${t("Save")}`
              ) : (
                <CircularProgress size="15px" />
              )}
            </Button>
          </div>
        </div>
      </Modal>
      {/* Opening modal while assigning staff */}
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openAssign}
        onClose={() => setOpenAssign(false)}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            {t("Assign staff for cleaning room")}
          </div>
          {selectedRoomId?.length > 0 ? (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{ marginTop: "auto", marginBottom: "auto" }}
              >
                {t("Selected room Ids:")}
              </div>
              <div
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {selectedRoomId.map((item) => (
                  <div style={{ marginLeft: "5px" }}>
                    <Chip label={item} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Typography align="center">{t("No rows selected")}</Typography>
          )}
          <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-autowidth-label">
              {t("Select Staff")}
            </InputLabel>
            <Select
              value={staffVal.selectedStaffName}
              onChange={handleStaffChange}
              id="controllable-states-demo"
              labelId="demo-simple-select-autowidth-label"
              sx={{ width: 500 }}
              input={<OutlinedInput label={t("Select Staff")} />}
            >
              {staffData?.map((item, index) => (
                <MenuItem key={index} name={item.email} value={item.email}>
                  {item.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
            }}
          >
            <Button variant="secondary" onClick={() => setOpenAssign(false)}>
              {t("Close")}
            </Button>
            <Button
              variant="custom-button"
              onClick={handleBulkAssignDirty}
              disabled={
                !selectedRoomId?.length > 0 || !staffVal?.selectedStaffId
              }
            >
              {!bulkDirtyLoader ? (
                `${t("Save")}`
              ) : (
                <CircularProgress size="15px" />
              )}
            </Button>
          </div>
        </div>
      </Modal>
      {/* Opening modal while unassign staff */}
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openUnassign}
        onClose={() => setOpenUnassign(false)}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            {t("Unassign staff from room")}
          </div>
          {selectedRoomId?.length > 0 ? (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{ marginTop: "auto", marginBottom: "auto" }}
              >
                {t("Selected room Ids:")}
              </div>
              <div
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {selectedRoomId.map((item) => (
                  <div style={{ marginLeft: "5px" }}>
                    <Chip label={item} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Typography align="center"> {t("No rows selected")}</Typography>
          )}

          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
            }}
          >
            <Button variant="secondary" onClick={() => setOpenUnassign(false)}>
              {t("Close")}
            </Button>
            <Button
              variant="custom-button"
              onClick={handleBulkUnassign}
              disabled={!selectedRoomId?.length > 0}
            >
              {!bulkDirtyLoader ? (
                `${t("Save")}`
              ) : (
                <CircularProgress size="15px" />
              )}
            </Button>
          </div>
        </div>
      </Modal>

      {/* Opening modal for admin remark and staff assignment  */}
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openAdminModal}
        onClose={onCloseAdminModal}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            {t("Bulk assign room and add remark")}
          </div>
          {selectedRoomId?.length > 0 ? (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{ marginTop: "auto", marginBottom: "auto" }}
              >
                {t("Selected room Ids:")}
              </div>
              <div
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {selectedRoomId.map((item) => (
                  <div style={{ marginLeft: "5px" }}>
                    <Chip label={item} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Typography align="center"> {t("No rows selected")}</Typography>
          )}
          <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-autowidth-label">
              {t("Select Staff")}
            </InputLabel>
            <Select
              value={staffVal.selectedStaffName}
              onChange={handleStaffChange}
              id="controllable-states-demo"
              labelId="demo-simple-select-autowidth-label"
              sx={{ width: 500 }}
              input={<OutlinedInput label={t("Select Staff")} />}
            >
              {staffData?.map((item, index) => (
                <MenuItem key={index} name={item.email} value={item.email}>
                  {item.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label={t("Supervisor Remark")}
            className="input-lg w-100 mt-3"
            placeholder={t("Enter supervisor remark here")}
            onChange={(e) => setRemark(e.target.value)}
            value={remark}
            name="Supervisor Remark"
            id="Supervisor Remark"
          />
          <TextField
            label={t("Staff Remark")}
            className="input-lg w-100 mt-3"
            placeholder={t("Enter remark here")}
            onChange={(e) => setstaffRemark(e.target.value)}
            value={staffRemark}
            name="Staff Remark"
            id="Staff Remark"
          />
          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
            }}
          >
            <Button variant="secondary" onClick={onCloseAdminModal}>
              {t("Close")}
            </Button>
            <Button
              variant="custom-button"
              onClick={handleBulkAssignment}
              disabled={
                !selectedRoomId?.length > 0 ||
                !staffVal.selectedStaffName ||
                assignLoader
              }
            >
              {t("Save")} {assignLoader && <CircularProgress size="15px" />}
            </Button>
          </div>
        </div>
      </Modal>

      {/* Opening modal while marking the rooms bulk staff remark */}
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openStaffModal}
        onClose={onCloseStaffModal}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            {t("Bulk Add Staff Remark")}
          </div>
          {selectedRoomId?.length > 0 ? (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{ marginTop: "auto", marginBottom: "auto" }}
              >
                {t("Selected room Ids:")}
              </div>
              <div
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {selectedRoomId.map((item) => (
                  <div style={{ marginLeft: "5px" }}>
                    <Chip label={item} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Typography align="center">{t("No rows selected")}</Typography>
          )}
          <TextField
            label={t("Staff Remark")}
            className="input-lg w-100 mt-3"
            placeholder={t("Enter remark here")}
            onChange={(e) => setstaffRemark(e.target.value)}
            value={staffRemark}
            name="Staff Remark"
            id="Staff Remark"
          />

          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
            }}
          >
            <Button variant="secondary" onClick={onCloseStaffModal}>
              {t("Close")}
            </Button>
            <Button
              variant="custom-button"
              onClick={handleBulkStaffRemark}
              disabled={!selectedRoomId?.length > 0 || !staffRemark}
            >
              {t("Confirm")} {loader && <CircularProgress size="15px" />}
            </Button>
          </div>
        </div>
      </Modal>

      {/* Opening modal while marking the rooms bulk clean */}
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        open={openClean}
        onClose={onCloseCleanModal}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            {t("Bulk Mark Clean")}
          </div>
          {selectedRoomId?.length > 0 ? (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{ marginTop: "auto", marginBottom: "auto" }}
              >
                {t("Selected room Ids:")}
              </div>
              <div
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {selectedRoomId.map((item) => (
                  <div style={{ marginLeft: "5px" }}>
                    <Chip label={item} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Typography align="center">{t("No rows selected")}</Typography>
          )}

          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
            }}
          >
            <Button variant="secondary" onClick={onCloseCleanModal}>
              {t("Close")}
            </Button>
            <Button
              variant="custom-button"
              onClick={handleBulkClean}
              disabled={!selectedRoomId?.length > 0}
            >
              {!loader ? `${t("Confirm")}` : <CircularProgress size="15px" />}
            </Button>
          </div>
        </div>
      </Modal>
    </Stack>
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel, hotelType: state.auth.hotelType };
}
export default connect(mapStateToProps)(HouseKeepingCharterTable2);
